'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleReceiveWidgetData = undefined;

var _bootstrapWidget = require('../../actions/bootstrapWidget');

var _bootstrapWidget2 = _interopRequireDefault(_bootstrapWidget);

var _initializeI18n = require('../../actions/initializeI18n');

var _ThreadActions = require('../../threads/actions/ThreadActions');

var _loadStagedThread = require('../../navigation/actions/loadStagedThread');

var _setThreadsSuccess = require('../../threads/actions/setThreadsSuccess');

var _getShouldFetchInitialVisitorThreads = require('../../threads/selectors/getShouldFetchInitialVisitorThreads');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleReceiveWidgetData = exports.handleReceiveWidgetData = function handleReceiveWidgetData(_ref) {
  var data = _ref.data;
  return function (dispatch, getState) {
    if (data) {
      return dispatch((0, _initializeI18n.initializeI18n)({ data: data })).then(function () {
        dispatch((0, _bootstrapWidget2.default)(data));

        var shouldFetchVisitorThreads = (0, _getShouldFetchInitialVisitorThreads.getShouldFetchInitialVisitorThreads)(getState());

        if (shouldFetchVisitorThreads) {
          dispatch((0, _ThreadActions.fetchVisitorThreads)()).then(function () {
            dispatch((0, _ThreadActions.navigateToMostRecentThread)());
          });
        } else {
          dispatch((0, _setThreadsSuccess.setThreadsSuccess)());
          dispatch((0, _loadStagedThread.loadStagedThread)());
        }
      }, function () {
        dispatch((0, _bootstrapWidget2.default)(data));
      });
    }
    return null;
  };
};